import {TemplateNode, getTemplateNodeReturns, type TemplateNodeDefinition} from "@cm/template-nodes"
import type {z as zMini} from "zod/v4-mini"

// A minimal, value-only `TemplateNode` subclass for inspector selection slots (dropdowns backed by
// `ValueSlotComponent`). These nodes are never registered or serialized — they only hold the selected
// value. `updateParameters` is a no-op so the value slot can't write back implicitly; the owning
// component pushes changes via `updateParametersExplicit`.
//
// `parametersSchema` is intentionally typed `unknown` (cast internally): some inspectors reuse one
// container dummy node across value slots that bind via *different* `[key]` values, so the parameter
// type must stay loose — `T` falls back to `Record<string, unknown>` when a caller omits it. A precise
// `ZodMiniType<T, T>` would infer a single-key `T` and over-narrow the `[key]` bindings at those sites.
export function createSelectorDummyNode<T extends Record<string, unknown>>(parametersSchema: unknown, nodeClass: string) {
    const definition: TemplateNodeDefinition<T, T> = {
        nodeClass,
        validation: {parameters: parametersSchema as zMini.ZodMiniType<T, T>, returns: getTemplateNodeReturns()},
    }
    return class extends TemplateNode<T, T> {
        public override get definition() {
            return definition
        }
        override updateParameters(_newParameters: Partial<T>) {}
        updateParametersExplicit(newParameters: Partial<T>) {
            super.updateParameters(newParameters as T)
        }
    }
}
